/**
 * Valores que significam "este build não sabe qual é a sua versão" — build
 * local, self-hosted, ou deploy sem metadados de git. Herdados do mecanismo
 * anterior (`build-id/compare.ts`), onde já existiam pelo mesmo motivo.
 */
const UNKNOWN_VALUES = new Set(['local', 'unknown', 'undefined', 'null'])

export type BuildMetadata = {
  /** Versão semântica do `package.json` deste build. */
  version: string | null
  /** Commit sha curto do deploy, só para observabilidade. */
  sha: string | null
}

const normalize = (value: unknown): string | null => {
  if (typeof value !== 'string') return null

  const normalized = value.trim()

  if (!normalized) return null
  if (UNKNOWN_VALUES.has(normalized.toLowerCase())) return null

  return normalized
}

/**
 * Lê os metadados assados no bundle. Puro e parametrizado para ser testável
 * sem depender de `import.meta.env` — que é substituído em build time e não dá
 * para forjar em teste.
 *
 * Versão desconhecida vira `null`, e `null` faz o comparador devolver `null`:
 * um bundle que não sabe a própria versão nunca recarrega sozinho.
 */
export const readBuildMetadata = (
  env: Record<string, unknown> = {}
): BuildMetadata => ({
  version: normalize(env.VITE_APP_VERSION),
  sha: normalize(env.VITE_BUILD_SHA)
})

export const buildMetadata = readBuildMetadata(
  import.meta.env as unknown as Record<string, unknown>
)
